import { api } from "./api.service";

export type NotificationItem = {
  id: string;
  createdAt: string;
  title: string;
  body: string;
  type: string;
  wasRead: boolean;
  url?: string | null;
  userId?: string | null;
};

export async function listMyNotifications(params?: {
  take?: number;
  skip?: number;
  unreadOnly?: boolean;
}): Promise<{ items: NotificationItem[]; unreadCount: number }> {
  const { data } = await api.get("/notifications", {
    params: {
      take: params?.take,
      skip: params?.skip,
      unreadOnly: params?.unreadOnly ? "true" : undefined,
    },
  });

  return {
    items: (data?.items ?? []) as NotificationItem[],
    unreadCount: Number(data?.unreadCount ?? 0),
  };
}

export async function getUnreadNotificationsCount(): Promise<number> {
  const { data } = await api.get("/notifications/unread-count");
  return Number(data?.unreadCount ?? 0);
}

export async function markNotificationAsRead(id: string) {
  const { data } = await api.patch(`/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsAsRead() {
  const { data } = await api.patch(`/notifications/read-all`);
  return data;
}
